import { useEffect, useState } from 'react'
import { useMapboxContext } from '../map/context'
import ControlBase from './base'
import Root from '@component/appendRoot'

export default function useControl (children, {position, groupClass = true, className = ''}) {

  const { mapLoaded, map } = useMapboxContext()
  const [container, setContainer] = useState(null)

  useEffect(() => {

    if (!mapLoaded) return

    const control = new ControlBase(groupClass, className)
    map.addControl(control, position)
    setContainer(control._container)

    return () => {
      map.removeControl(control)
    }
  }, [mapLoaded, map, position, groupClass, className])

  return container && (
    <Root container={container}>
      {children}
    </Root>
  )
}